import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import {
  FaTwitter,
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaWhatsapp,
  FaArrowUp,
  FaAngleRight,
} from "react-icons/fa";

const Footer = () => {
  const [showArrow, setShowArrow] = useState(false);
  const [data, setData] = useState({
    infoBar: {},
    about: { social: {} },
    quickLinks: [],
    activities: []
  });

  /* SCROLL TO TOP ARROW */
  useEffect(() => {
    const onScroll = () => setShowArrow(window.scrollY > 200);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* JSON + XML */
  useEffect(() => {
    // ✅ JSON → UI
    fetch("/api/footer.json")
      .then(res => res.json())
      .then(json => {
        console.log("FOOTER JSON:", json);
        setData(json);
      });

    // ✅ XML → exam proof
    fetch("/api/footer.xml")
      .then(res => res.text())
      .then(() => console.log("Footer XML loaded"));
  }, []);

  const scrollToTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <>
      <footer>

        {/* ===== TOP INFO BAR ===== */}
        <div className="footer-info-bar">

          <div className="footer-info-item">
            <img src={data.infoBar.phone?.icon} alt="" />
            <div>
              <strong>{data.infoBar.phone?.label}:</strong><br />
              <a href={data.infoBar.phone?.link}>
                <strong>{data.infoBar.phone?.value}</strong>
              </a>
            </div>
          </div>

          <div className="footer-info-item">
            <img src={data.infoBar.email?.icon} alt="" />
            <div>
              <strong>{data.infoBar.email?.label}:</strong><br />
              <a href={data.infoBar.email?.link}>
                <strong>{data.infoBar.email?.value}</strong>
              </a>
            </div>
          </div>

          <div className="footer-info-item">
            <img src={data.infoBar.address?.icon} alt="" />
            <div>
              <strong>{data.infoBar.address?.label}:</strong><br />
              <strong>{data.infoBar.address?.value}</strong>
            </div>
          </div>

        </div>

        {/* ===== BOTTOM FOOTER ===== */}
        <div className="footer-bottom">

          {/* ABOUT */}
          <div className="footer-column">
            <h3>About Us</h3>
            <img src={data.about.logo} className="footer-logo" alt="" />
            <p>{data.about.text}</p>

            <div className="social-icons">
              <a href={data.about.social.twitter}><FaTwitter /></a>
              <a href={data.about.social.facebook}><FaFacebookF /></a>
              <a href={data.about.social.linkedin}><FaLinkedinIn /></a>
              <a href={data.about.social.instagram}><FaInstagram /></a>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div className="footer-column">
            <h3>Quick Links</h3>
            <ul>
              {data.quickLinks.map((item, i) => (
                <li key={i}>
                  <Link to={item.path}>
                    <span className="double-arrow">
                      <FaAngleRight /><FaAngleRight />
                    </span>
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ACTIVITIES */}
          <div className="footer-column">
            <h3>Activities</h3>
            <ul>
              {data.activities.map((item, i) => (
                <li key={i}>
                  <Link to={item.path}>
                    <span className="double-arrow">
                      <FaAngleRight /><FaAngleRight />
                    </span>
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* MAP */}
          <div className="footer-column">
            <h3>Get In Touch</h3>
            <div className="footer-map">
              <iframe
                src={data.map?.iframe}
                allowFullScreen
                loading="lazy"
                title="Map"
              />
            </div>
          </div>

        </div>

        <div className="footer-copy">
          {data.copyright}
        </div>
      </footer>

      {/* WHATSAPP */}
      <a
        href={data.whatsapp}
        target="_blank"
        rel="noreferrer"
        className="whatsapp-btn"
      >
        <FaWhatsapp />
      </a>

      {/* SCROLL TO TOP */}
      {showArrow && (
        <div className="scroll-arrow" onClick={scrollToTop}>
          <FaArrowUp />
        </div>
      )}

      {/* ================= CSS INSIDE FOOTER ================= */}
      <style>{`
 .footer-info-bar {
  background: #a5cf4b;
  border-radius: 50px;
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 112px;
  max-width: 1250px;
  margin: 0 auto;
  position: absolute;
  margin-top: -53px;
  margin-left: 127px;
}

.footer-info-item {
  display: flex;
  align-items: center;
  gap: 15px;
  font-size: 14px;
  color: #000;
}

.footer-info-item img {
  width: 47px;
}

.footer-info-item strong {
  font-weight: bold;
}

/* Top Contact Strip */
.footer-top {
  background: #a6d62f;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 15px;
  flex-wrap: wrap;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 300px;
}

.contact-item i {
  font-size: 20px;
  color: #000;
}

/* Bottom Footer */
.footer-bottom {
    background: url("/assets/footer bg.jpg") no-repeat center center;
    background-size: cover; /* pooro fill thay */
    color: white;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
    gap: 30px;
    padding: 86px 25px 17px;
    margin-top: 32px;
}


.footer-column h3 {
  color: var(--primary-color);
  border-bottom: 1px solid var(--primary-color);
  display: inline-block;
  margin-bottom: 32px;
}

.footer-column p {
  font-size: 14px;
  height:100px;
  line-height: 1.6;
  color: #fff;
  font-weight: 500;
  font-family: var(--secondary-font-family);
}

.footer-column ul {
  list-style: none;
  hight: 150px;
  padding: 0;
}

.footer-column ul li {
  margin-bottom: 30px;
  color: #fff;
  font-family: var(--secondary-font-family);
  font-size: 17px;
}

.footer-column ul li a {
  text-decoration: none;
  color: #fff;
  transition: 0.3s;
  font-size: 15px;
}

.footer-column ul li a:hover {
  color: #a6d62f;
}
a {
    color: rgb(5 5 3);
    text-decoration: none;
}
.footer-logo {
  width: 114px;
  display: block; 
  margin-bottom: 10px;
}

.social-icons {
  margin-top: 10px;
}

.social-icons a {
  display: inline-flex;
  width: 35px;
  height: 35px;
  justify-content: center;
  align-items: center;
  background: var(--primary-color);
  color: black;
  border-radius: 50%;
  margin-right: 5px;
  transition: 0.3s;
}

.social-icons a:hover {
  background: white;
}

/* Copyright */
.footer-copy {
  background: #111;
  color: #fff;
  text-align: center;
  padding: 25px;
  font-size: 16px;
  font-family: var(--secondary-font-family);
}

.footer-info-bar {
  background: #a5cf4b;
  border-radius: 50px;
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 50px;
  max-width: 1250px;
  margin: 0 auto; /* center horizontally */
  position: relative;
  top: 71px; /* negative margin replace kari ne relative position use kariye */
}

@media (max-width: 992px) {
  .footer-info-bar {
    flex-direction: column;
    gap: 20px;
    text-align: center;
    border-radius: 30px;
    padding: 20px;
  }
}

.footer-info-item {
  display: flex;
  align-items: center;
  gap: 15px;
  font-size: 14px;
  color: #000;
}

.footer-info-item img {
  width: 47px;
}

.footer-info-item strong {
  font-weight: bold;
}


/* WhatsApp Button (left) */
.whatsapp-btn {
    position: fixed;
    left: 20px;
    bottom: 50px;
    background-color: #25d366;
    color: #fff;
    font-size: 30px;
    padding: 15px;
    border-radius: 50%;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    box-shadow: 0 0 15px rgba(0,0,0,0.3);
    animation: pulse 1.5s infinite;
}

.whatsapp-btn:hover {
  color: #fff;
}

/* Pulse animation for WhatsApp button */
@keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.2); }
    100% { transform: scale(1); }
}

/* Arrow (right) */
.scroll-arrow {
    position: fixed;
    right: 20px;
    bottom: 50px;
    font-size: 26px;
    color: var(--primary-color);
    background-color: #000;
    animation: bounce 2s infinite;
    z-index: 1000;
    padding: 13px 18px;
}

.scroll-arrow:hover {
  color: #000;
  background-color: #fff;
}


/* Bounce animation for arrow (down-to-top) */
@keyframes bounce {
    0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
    40% { transform: translateY(-20px); }
    60% { transform: translateY(-10px); }
}

/* Responsive adjustments for mobile */
@media screen and (max-width: 768px) {
    .whatsapp-btn {
        font-size: 24px;
        padding: 12px;
        left: 15px;
        bottom: 40px;
    }
    .scroll-arrow {
        font-size: 22px;
        padding: 10px 14px;
        right: 15px;
        bottom: 40px;
    }
}

@media screen and (max-width: 480px) {
    .whatsapp-btn {
        font-size: 20px;
        padding: 10px;
        left: 12px;
        bottom: 30px;
    }
    .scroll-arrow {
        font-size: 18px;
        padding: 8px 12px;
        right: 12px;
        bottom: 30px;
    }
}
    .footer-map iframe {
  width: 100%;
  height: 320px;   
  display: block;
}
@media (max-width: 768px) {
  .footer-map iframe {
    height: 260px;
  }
}

@media (max-width: 480px) {
  .footer-map iframe {
    height: 220px;
  }
}

.double-arrow {
  display: inline-flex;   
  align-items: center;
  margin-right: 6px;
}

.double-arrow svg {
  font-size: 14px;          
  margin-right: -5px;       
}
  .footer-column ul li a:hover .double-arrow {
  transform: translateX(4px);
  transition: 0.3s;
}



      `}</style>

     
    </>
  );
};

export default Footer;
